import React from "react";
import Hero from "../assets/Heropic.jpg";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { DiMongodb,DiJavascript1 ,DiReact,DiNodejs} from "react-icons/di";
import { SiSolidity ,SiChainlink} from "react-icons/si";
import { Link } from "react-scroll";
import '../App.css';

const Home = () => {
  return (
    <div
      name="home"
      className="h-screen w-full "
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-11 md:flex-row">
        <div className="flex flex-col justify-center h-full md:px-0  ">
          <h2 data-aos="fade-right" data-aos-offset="300"  data-aos-duration="900" data-aos-easing="ease-in-sine" className="md:text-4xl text-2xl w-96 mx-auto md:mx-0 mt-96 pt-11 md:mt-2 sm:text-6xl font-bold text-white">
            I'm a <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-500 text-5xl font-black">Full Stack WEB-3</span> Developer
          </h2>
          <p className="text-black py-4 font-semibold w-96 mx-auto md:mx-0 md:max-w-md">
          I am M.E.R.N.S(solidity) Developer who is passionate about WEB and WEB-3. Blockchain Technology is the one that has changed the perspective of my life. Below are some major technologies I am working currently on.
          </p>
          <p className=" flex items-center">
            <DiJavascript1 size={40} className="m-4" data-aos="zoom-out-up" data-aos-duration="900"  />
            <DiMongodb size={40} className="m-4" data-aos="zoom-out-up" data-aos-duration="1100" / >
            <DiNodejs size={50} className="m-4"  data-aos="zoom-out-up" data-aos-duration="1300"/ >
            <DiReact size={40} className="m-4" data-aos="zoom-out-up" data-aos-duration="1500" />
            <SiChainlink size={40} className="m-4" data-aos="zoom-out-up" data-aos-duration="1700" />
            <SiSolidity size={40} className="m-4" data-aos="zoom-out-up" data-aos-duration="2000"  />
          </p>

          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className=" hidden group text-white w-fit px-6 py-3 my-2 md:flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <MdOutlineKeyboardArrowRight size={25} className="ml-1" />
              </span>
            </Link>
          </div>
        </div>

        <div>
          <a ><img  src={Hero}
            alt="my profile"
            className="rounded-2xl mx-auto w-3/4 md:w-full md:pb-1 pb-72 pt-16 "/>
            </a>
        </div>
      </div>
    </div>
  );
};

export default Home;